<template>
    <div class="c-head-btn" :class="color" @click="click">
        <span>{{ text }}</span>
        <img :src="require(`@/assets/${img}`)" alt="img" v-if="img">
    </div>
</template>

<script>
export default {
    props: {
        text: String,
        img: String,
        click: Function,
        color: String
    },
    data: function() {
        return {}
    }
}
</script>

<style lang="sass">

div.c-head-btn
    display: flex
    justify-content: center
    align-items: center
    padding: 10px
    min-width: 175px
    min-height: 44px
    border-radius: 8px
    border: 2px solid transparent
    background: linear-gradient(to bottom,#3c6399 0%,#0f2e50 100%)
    //background: linear-gradient(0deg, rgba(255, 170, 0, 0.60) 0%, rgba(255, 170, 0, 0.60) 100%), linear-gradient(0deg, #FFFFFF, #FFFFFF)
    // background: #7ed3d4

    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.16)
    cursor: pointer

    span
        //color: #2178D5
        color: white
        text-transform: uppercase
        font-weight: 500
        font-size: 1.5em
        //font-size: 18px
    
    img
        margin-left: 10px
        filter: grayscale(100%) brightness(0) invert(1)

    &.red
        background: linear-gradient(to bottom, rgba(191, 30, 46, 1) 0%, rgba(77, 16, 19, 1) 100%)

div.c-head-btn:hover
  border: 2px solid #3c6399
  background: white

div.c-head-btn:hover span
    color: #3c6399

@media screen and (max-width: 768px)
  div.c-head-btn
    min-width: 145px

  div.c-head-btn span
   font-size: 1.4em


@media screen and (max-width: 550px)
  div.c-head-btn
    min-height: 25px
    min-width: 250px
    padding: 5px


  div.c-head-btn span
    font-size: 1.2em
</style>